import { render, staticRenderFns } from "./UpdateDeliveryMethod.vue?vue&type=template&id=33427170&scoped=true&"
import script from "./UpdateDeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./UpdateDeliveryMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33427170",
  null
  
)

export default component.exports